exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".conflict-section[data-v-1f2af4fc] {\n  margin-bottom: 16px;\n}\n.conflict-title[data-v-1f2af4fc] {\n  margin-bottom: 8px;\n  color: #252525;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.5;\n}\n.conflict-tips[data-v-1f2af4fc] {\n  margin-bottom: 12px;\n  color: #606266;\n  font-size: 13px;\n  line-height: 1.6;\n}", ""]);

// exports
